<footer class="footer">
    <div class="container-fluid">
        <nav class="pull-left">
            <ul>
                <li>
                    <a href="https://www.ait.ac.at">&copy; {{test | date: 'yyyy'}} AIT Austrian Institute of Technology GmbH</a>
                </li>
                <li>
                    <a href="/disclaimer">
                        Disclaimer
                    </a>
                </li>
                <li>
                    <a href="/impressum">
                        Impressum
                    </a>
                </li>

            </ul>
        </nav>
        <div class="pull-right">
            <img height="50px" src="../../../assets/img/logos/logo_ait.jpg" />
        </div>
    </div>
</footer>
